module.exports = __webpack_public_path__ + "img/WannaBePosturePerfectOfficeEE.786c97c4.png";